const K_WIDTH = 40;
const K_HEIGHT = 40;
const O_HEIGHT = 200;
const O_WIDTH = 200;

const styles = {
  markerIconStyle: {
    borderRadius: 24,
    height: 18,
    left: -K_WIDTH / 2,
    top: -K_HEIGHT / 2,
    width: 52,
  },
  newMarkerStyle: {
    height: 12,
    marginLeft: -5,
    width: 32,
  },
  overlayContainer: {
    color: 'black',
    left: -O_WIDTH / 2,
    top: -O_HEIGHT / 2,
  },
};

export default styles;
